import { getGreenColors } from '@panel/commons/lib/theme';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const ProgressContainer = styled.div`
  border-radius: 8px 8px 0px 0px;
  overflow: hidden;
  width: 100%;
  height: 8px;
`;

const Progress = styled.div`
  background-color: ${getGreenColors('base')};
  width: ${({ progress }) => `${progress}%`};
  height: 100%;
  transition: width 0.1s linear;
`;

const ProgressBar = ({ time }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    setProgress(0);
    const interval = setInterval(() => {
      setProgress(prevProgress => Math.min(prevProgress + 100 / (time / 100), 100));
    }, 100);
    return () => clearInterval(interval);
  }, [time]);

  return (
    <ProgressContainer>
      <Progress progress={progress} />
    </ProgressContainer>
  );
};

export default ProgressBar;
